import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { RoleName } from './models';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  return auth.isAuthenticated() ? true : inject(Router).createUrlTree(['/login']);
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  return auth.isAuthenticated() ? inject(Router).createUrlTree(['/']) : true;
};

/** Usa `data: { roles: [...] }` y/o `data: { permission: '...' }` de la ruta. */
export const accessGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const roles = route.data['roles'] as RoleName[] | undefined;
  const permission = route.data['permission'] as string | undefined;

  const allowed = (!roles || auth.hasRole(...roles)) && (!permission || auth.can(permission));
  return allowed ? true : inject(Router).createUrlTree(['/']);
};
